import type { OliveError } from '~/api/oliveError.api'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useErrorsStore = defineStore('errors', () => {
  // #region state
  const error = ref<OliveError>()

  return {
    error,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useErrorsStore as any, import.meta.hot))
